import React from 'react';
const painPoints = [{
  icon: '💸',
  title: 'El costo de vida sube pero tu ingreso no',
  desc: 'Cada mes es una lucha para llegar a fin de mes mientras los precios no paran de subir.'
}, {
  icon: '👶',
  title: 'No quieres dejar a tus hijos 10 horas en daycare',
  desc: 'Para ganar el mínimo tendrías que sacrificar los años más importantes de tus hijos.'
}, {
  icon: '😔',
  title: 'Sientes que perdiste tu identidad profesional',
  desc: 'Amas ser mamá, pero extrañas sentir que produces, que aportas, que tienes tu propio dinero.'
}];
export function Empathy() {
  return <section className="bg-[#fdf6ee] py-16 md:py-24" data-id="element-135">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-136">
        {/* Label */}
        <div className="text-center mb-10" data-id="element-137">
          <span className="font-dm text-xs font-bold tracking-widest text-[#c9a84c] uppercase" data-id="element-138">
            Te entiendo
          </span>
        </div>

        {/* Main empathy copy */}
        <div className="text-center mb-12" data-id="element-139">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-[#0d4a45] leading-tight mb-6" data-id="element-140">
            Sé lo que se siente mirar el saldo de la cuenta a mitad de mes...
          </h2>
          <div className="max-w-2xl mx-auto space-y-4 text-[#3a3a3a] text-lg font-dm leading-relaxed" data-id="element-141">
            <p data-id="element-142">
              Ver cómo el costo de vida en este país no perdona, mientras tú
              sientes que tu único rol es limpiar, cocinar y cuidar.
            </p>
            <p className="font-medium text-[#0d4a45]" data-id="element-143">
              Amas a tus hijos, pero extrañas sentir que produces, que aportas,
              que tienes{' '}
              <span className="text-[#c9a84c] font-bold" data-id="element-144">tu propio dinero</span>{' '}
              para lo que tú quieras sin pedir permiso.
            </p>
          </div>
        </div>

        {/* Pain point cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-145">
          {painPoints.map(point => <div key={point.title} className="bg-white border-l-4 border-[#0d4a45] rounded-xl p-6 shadow-sm" data-id="element-146">
              <div className="text-3xl mb-3" data-id="element-147">{point.icon}</div>
              <h3 className="font-playfair font-bold text-[#0d4a45] text-lg mb-2" data-id="element-148">
                {point.title}
              </h3>
              <p className="font-dm text-[#5a5a5a] text-sm leading-relaxed" data-id="element-149">
                {point.desc}
              </p>
            </div>)}
        </div>

        {/* Transition */}
        <div className="mt-12 text-center" data-id="element-150">
          <p className="font-playfair italic text-[#0d4a45] text-xl md:text-2xl" data-id="element-151">
            "Pero ¿y si te dijera que hay una salida que no requiere sacrificar
            a tu familia?"
          </p>
        </div>
      </div>
    </section>;
}